import React, {useContext, useEffect, useState} from 'react';
import {ProductPageContext } from './productPageContext.js';
import useExperienceApi from '../../../experiences/lib/useExperienceApi.js';
import { ProductContext } from '../../lib/productContext.js';
import usePersonaApi from '@/persona/lib/usePersonaApi.js';
import { useSharedExperiencesApi } from '@/shared-experiences/lib/useSharedExperiencesApi';
import { AuthContext } from '@/auth/lib/authContext.js';
import { useLocation } from 'react-router-dom';
export default function ProductPageProvider({children}) {
  const {
    productId,
  } = useContext(ProductContext);
  const {profile} = useContext(AuthContext)
  const personaApi = usePersonaApi();
  const experienceApi = useExperienceApi();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const [isFetchingPersonaList, setIsFetchPersonaList] = useState(false);
  const [isFetchingExperiences, setIsFetchingExperiences] = useState(false);
  const [isFetchingSharedExperiences, setIsFetchingSharedExperiences] = useState(false);
  const [personaList, setPersonaList] = useState([]);
  const [experienceList, setExperienceList] = useState(null);
  const [experienceGroupList, setExperienceGroupList] = useState(null);
  const [experiencesPersona, setExperiencesPersona] = useState(null);
  const [sharedExperienceList, setSharedExperienceList] = useState(null);
  const [init, setInit] = useState(false);
  const [editingValueProposition, setEditingValueProposition] = useState(false);
  const [editingTypes, setEditingTypes] = useState(false);
  const [editingMainFeatures, setEditingMainFeatures] = useState(false);
  const [editingUsefulLinks, setEditingUsefulLinks] = useState(false);
  const [previousProductId, setPreviousProductId] = useState(null);
  const [group, setGroup] = useState(null);
  const [parentGroup, setParentGroup] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const groupId = searchParams.get('group-id');
  const refreshPersonaList = async () => {
    try {
      setIsFetchPersonaList(true);
      const newPersonaList = await personaApi.fetchManyPersonaByProductId(productId);
      setPersonaList(newPersonaList);
      setIsFetchPersonaList(false);
    } catch (error) {
      console.error(error)
    }
  }
  const refreshSharedExperienceList = async () => {
    try {
      setIsFetchingSharedExperiences(true);
      const newSharedExperienceList = await sharedExperiencesApi.fetchSharedExperiencesByProductId(productId);
      setSharedExperienceList(newSharedExperienceList || []);
      setIsFetchingSharedExperiences(false);
    } catch (error) {
      console.error('❌ Error in refreshSharedExperienceList:', error);
      setIsFetchingSharedExperiences(false);
    }
  }
  const refreshExperienceList = async () => {
    try {
      setIsFetchingExperiences(true);
      const result = await Promise.all([
        experienceApi.fetchExperiencesByProductId(productId),
        experienceApi.fetchExperienceGroupsByProductId(productId),
        personaApi.fetchPersonaListWithExperienceByProductId(productId)
      ]);
      setExperienceList((result[0] || []));
      setExperienceGroupList(result[1] || []);
      setExperiencesPersona(result[2]);
    } catch (error) {
      console.error('Error refreshing experience list:', error);
    } finally {
      setIsFetchingExperiences(false);
    }
  }
  const refreshAll = async () => {
    await Promise.all([
      refreshPersonaList(),
      refreshExperienceList(),
      refreshSharedExperienceList()
    ]);
  }
  useEffect(() => {
    if (productId && profile) {
      if(!init || productId !== previousProductId) {
        setPreviousProductId(productId)
        refreshAll();
        setInit(true);
      }
    }
  }, [productId,  profile]);
  useEffect(() => {
    if (experienceGroupList) {
      if (groupId) {
        const newGroup = (experienceGroupList.filter(g => g.id === parseInt(groupId)))[0];
        setGroup(newGroup);
        if(newGroup) {
          const parentGroup = experienceGroupList.find(g => newGroup.group_id === g.group.id);  
          setParentGroup(parentGroup);
        }
      } else {
        setGroup(null);
        setParentGroup(null);
      }
    }
  }, [groupId, experienceGroupList]);
  return (
    <ProductPageContext.Provider value={{
      isFetchingPersonaList,
      isFetchingExperiences,
      isFetchingSharedExperiences,
      personaList,
      experienceGroupList,
      refreshPersonaList: refreshPersonaList,
      refreshExperienceList: refreshExperienceList,
      refreshSharedExperienceList: refreshSharedExperienceList,
      refreshAll: refreshAll,
      experiencesPersona,
      experienceList,
      sharedExperienceList,
      editingValueProposition,
      setEditingValueProposition,
      editingMainFeatures,
      setEditingMainFeatures,
      editingUsefulLinks,
      setEditingUsefulLinks,
      editingTypes,
      setEditingTypes,
      group,
      parentGroup,
      setGroup,
    }}>
      {children}
    </ProductPageContext.Provider>
  );
}